import styled from 'styled-components';

import { colors } from 'theme';

export const PageHeaderSeparator = styled.div`
  width: 1px;
  height: 20px;
  background: ${colors.elementGrey};
  opacity: 0.5;
`;
